import { faCopy, faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { notification, QRCode } from "antd";
import { getBlobFromImageElement } from "copy-image-clipboard";
import React from "react";
import GlobalStoreContext from "../../../context/GlobalStoreContext";
import Helper from "../../../Helper";
import { Area } from "../../../models/Area";
import { CalendarEvent } from "../../../models/CalendarEvent";
import { Delivery } from "../../../models/Delivery";
import { Equipment } from "../../../models/Equipment";

interface Props {
    shareType: "location" | "project" | "delivery" | "equipment";
    currentObject?: Area | Equipment;
    calendarEvent?: CalendarEvent;
    delivery?: Delivery;
}

const ShareProjectItemQRCode: React.FC<Props> = (props) => {
    const globalStoreContext = React.useContext(GlobalStoreContext);

    const shareURL = () => {
        if (props.delivery) {
            return `${Helper.baseUrlWithPort()}/event/${props.delivery.uniqueToken}`;
        } else {
            let url = `${Helper.baseUrlWithPort()}/projects/${globalStoreContext.currentProjectInfo.unique_token}`;
            if (props.currentObject) {
                const mapObject = props.currentObject.getMapObject(globalStoreContext);

                if (mapObject) {
                    url += `/portal?mapObject=${mapObject.uuid}`;
                }
            }
            return url;
        }
    };

    const itemLabel = () => {
        switch (props.shareType) {
            case "location": {
                let name: string | null = null;

                if (props.currentObject instanceof Area) {
                    name = props.currentObject.areaName;
                } else if (props.currentObject instanceof Equipment) {
                    name = props.currentObject.equipmentName;
                }

                if (name && name.length > 0) {
                    return name;
                } else {
                    return "Location";
                }
            }
            case "project":
                return globalStoreContext.currentProjectInfo.project_name;
            case "delivery":
                return props.calendarEvent?.name;
        }
    };

    function doDownload(url: string, fileName: string) {
        const a = document.createElement("a");
        a.download = fileName;
        a.href = url;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    const downloadCanvasQRCode = () => {
        const canvas = document.getElementById("QRCode")?.querySelector<HTMLCanvasElement>("canvas");
        if (canvas) {
            const url = canvas.toDataURL();

            const fileName =
                "plot-" +
                itemLabel()
                    .split(" ")
                    .join("-")
                    .replace(/[^a-zA-Z0-9-_.]/g, "")
                    .substring(0, 20) +
                "-verified-qr-code.png";

            doDownload(url, fileName);
        }
    };

    const copyCanvasQRCode = async () => {
        const img = document.getElementById("HiddenQR") as HTMLImageElement;
        const canvas = document.getElementById("QRCode")?.querySelector<HTMLCanvasElement>("canvas");
        if (canvas && img) {
            img.src = canvas.toDataURL();
            try {
                const blob = await getBlobFromImageElement(img);
                await navigator.clipboard.write([
                    new ClipboardItem({
                        [blob.type]: blob,
                    }),
                ]);
                // message.success("QR code copied to clipboard");
                notification.success({
                    message: "QR code copied to clipboard",
                });
            } catch (err) {
                // message.error("Failed to copy QR code to clipboard");
                notification.error({
                    message: "Failed to copy QR code to clipboard",
                });
            }
        }
    };

    return (
        <div>
            <div>
                <QRCode
                    id="QRCode"
                    value={shareURL()}
                    style={{
                        margin: "0 auto",
                        marginBottom: "10px",
                        backgroundColor: "white",
                    }}
                    type="canvas"
                />

                <p className="text-center text-2xl font-bold">{itemLabel()?.toUpperCase()}</p>
            </div>
            <div className="flex flex-row items-center gap-2 mt-2">
                <button
                    className="hover:cursor-pointer w-1/2 text-xs bg-transparent hover:bg-neutral-100 border-1 border-transparent dark:border-neutral-300 p-2 rounded-lg"
                    type="button"
                    onClick={downloadCanvasQRCode}
                >
                    <FontAwesomeIcon style={{ marginRight: "7px" }} icon={faDownload} />
                    Download QR
                </button>
                <button
                    className="hover:cursor-pointer w-1/2 text-xs bg-transparent hover:bg-neutral-100 border-1 border-transparent dark:border-neutral-300 p-2 rounded-lg"
                    type="button"
                    onClick={copyCanvasQRCode}
                >
                    <FontAwesomeIcon style={{ marginRight: "7px" }} icon={faCopy} />
                    Copy QR
                </button>
            </div>
            <img id="HiddenQR" style={{ display: "none" }} />
        </div>
    );
};

export default ShareProjectItemQRCode;
